module.exports = __webpack_public_path__ + "img/evaluation-1.0966513f.png";